/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProductionReportDetailsQuery } from '../../models/get-production-report-details-query';
import { GetProductionReportDetailsQueryResult } from '../../models/get-production-report-details-query-result';

export interface ApiNurseryManagerReportsGetProductionDetailsReportPost$Plain$Params {
      body?: GetProductionReportDetailsQuery
}

export function apiNurseryManagerReportsGetProductionDetailsReportPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerReportsGetProductionDetailsReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProductionReportDetailsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerReportsGetProductionDetailsReportPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProductionReportDetailsQueryResult>;
    })
  );
}

apiNurseryManagerReportsGetProductionDetailsReportPost$Plain.PATH = '/api/NurseryManager/Reports/GetProductionDetailsReport';
